import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { submitGpsDevicesRequest, unlockGpsRequest } from '../../actions/gps';
import { companySelector } from '../../../company/selectors/company';
import { getCompanyRequest, setCompany } from '../../../company/actions/company';
import { gpsSelector } from '../../selectors/gps';
import FormGps from './FormGps';

const mapStateToProps = createStructuredSelector({
    gps: gpsSelector,
    company: companySelector
});

const mapDispatchToProps = {
    submitGpsDevicesRequest,
    getCompanyRequest,
    setCompany,
    unlockGpsRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(FormGps);